import { GradientLoadingBox } from 'edrolo-style-guide';
import styles from './GradientLoadingIndicator.scss';

const Divider = () => <div className={styles.divider} />;

const BoxRow = () => {
  return (
    <div className={styles.boxRow}>
      <GradientLoadingBox className={styles.box3} />
      <GradientLoadingBox className={styles.box4} />
    </div>
  );
};

const GradientLoadingIndicator = () => {
  return (
    <div className={styles.container}>
      <GradientLoadingBox className={styles.box1} />
      <GradientLoadingBox className={styles.box2} />
      <Divider />

      <BoxRow />
      <Divider />

      <BoxRow />
      <Divider />

      <BoxRow />
      <Divider />

      <BoxRow />
      <Divider />
    </div>
  );
};

export default GradientLoadingIndicator;
